import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const ElementListView = ({ value, columns, customRender }) => {
  if (!value || !value.length) return '-';
  return (
    <div className={classNames('flex', { 'flex-col': columns }, { 'items-center': !columns })}>
      {value.map((value, index) => <div key={index}
        className={classNames('flex flex-row items-center', { 'mr-2': !columns }, { 'mb-2': columns })}>
        <div className="flex-1">{customRender ? customRender(value, { value }) : value}</div>
      </div>)}
    </div>
  );
};

export default memo(ElementListView);

ElementListView.propTypes = {
  value: PropTypes.array,
  columns: PropTypes.bool,
  customRender: PropTypes.func,
  item: PropTypes.object,
};
